import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlCmsCopy} from '../getCmsCopy.api';
import {CmsCopy} from '../../../graphql/common.datatypes';

interface DeleteCmsCopyInput {
    id: number
}

interface DeleteCmsCopyData {
    deleteCmsCopy: CmsCopy
}

export const DELETE_CMS_COPY_MUTATION = gql`
    mutation deleteCmsCopy($id: Int!) {
        deleteCmsCopy(id: $id) {
            ${gqlCmsCopy}
        }
    }
`;

export const deleteCmsCopy = () => useMutation<DeleteCmsCopyData, DeleteCmsCopyInput>(
    DELETE_CMS_COPY_MUTATION,
    {
        update: updateCacheByType('CmsCopy'),
    }
);

export default deleteCmsCopy;